import APIFetcher from '../APIFetcher';

class StreamApi {
  static getStream({name}) {
    return APIFetcher.get(`stream/${name}`);
  }

  static postStream(payload) {
    return APIFetcher.post(`stream/${payload.name}`, {payload});
  }
}

export default StreamApi;
